import {
    new_request,
    // path,
    request,
    // String
} from './request'
// import axios from 'axios';


// 登录
export const login = (parmas) => {
    return request({
        url: '/v2/login',
        method: 'post',
        data: parmas
    })
}

//获取权限信息
export const getUserInfo =() =>{
    return request({
        url: '/user/authoInfo',
        method: 'get',
    })
}

//获取用户信息
export const getInfo =() =>{
    return request({
        url: '/user/info',
        method: 'get',
    })
}

//注册
export const register = (parmas) => {
    return request({
        url: '/user/register',
        method: 'post',
        data: parmas
    })
}


// 修改密码接口
export const updatePassword = (parmas) => {
    return request({
        url: '/user/update',
        method: 'post',
        data: parmas
    })
}

//地址列表
export const addressList = () => {
    return request({
        url: '/address',
        method: 'get',
    })
}

//新增地址信息
export const createAddress = (parmas) => {
    return request({
        url:'/address/create',
        method: 'post',
        data:parmas
    })
}

//修改地址信息
export const updateAddress = (parmas, id) => {
    return request({
        url:'/address?id='+id,
        method: 'post',
        data:parmas
    })
}

//删除地址信息
export const deleteAddress = (id) => {
    return request({
        url:'/address/delete?id='+id,
        method: 'post',
    })
}


//订单列表
export const orderList = (parmas) => {
    return request( {
        url: '/v2/order/list',
        method: 'post',
        data:parmas
    })
}

export const confirmOrder = (parmas) => {
    return request( {
        url: '/v2/order/confirm/order?orderId=' + parmas,
        method: 'post',
    })
}


export const cancelConfirmOrder = (parmas) => {
    return request( {
        url: '/v2/order/confirm/order?orderId=' + parmas,
        method: 'delete',
        data: null
    })
}


export const orderProduct = (parmas) => {
    return request( {
        url: '/v2/order/product/list',
        method: 'post',
        data:parmas
    })
}

export const deleteFileUrl = (parmas) => {
    return request( {
        url: '/v2/order/file/',
        method: 'delete_path',
        data: parmas,
    })
}

export const orderCount = (parmas) => {
    return request( {
        url: '/v2/order/report',
        method: 'post',
        data:parmas
    })
}

export const getOrderDetails = (parmas) => {
    return request( {
        url: '/v2/order/',
        method: 'get_path',
        data:parmas
    })
}

export const gotoPay = (parmas) => {
    return new_request( {
        url: '/v2/order/pay',
        method: 'put_body',
        param: "",
        data: parmas
    })
}

export const gotoCreate = (parmas) => {
    return new_request( {
        url: '/v2/order/createImage',
        method: 'put_body',
        param: "",
        data: parmas
    })
}

export const gotoInvoice = (parmas) => {
    return new_request( {
        url: '/v2/order/invoice',
        method: 'put_body',
        param: "",
        data: parmas
    })
}

export const gotoExamine = (parmas) => {
    return new_request( {
        url: '/v2/order/examine',
        method: 'put_body',
        param: "",
        data: parmas
    })
}

export const gotoDemandPayment = (params) => {
    return new_request( {
        url: '/v2/order/demandPayment',
        method: 'put_body',
        param: "",
        data: params
    })
}

export const orderStatistics = (parmas) => {
    return request( {
        url: '/v2/order/statistics',
        method: 'post',
        data:parmas
    })
}

export const orderProductStatistics = (parmas) => {
    return request( {
        url: '/v2/order/product/statistics',
        method: 'post',
        data:parmas
    })
}

//获取地址列表
export const getAddress = () => {
    return request({
        url:'/address',
        method: 'get'
    })
}

//修改订单数量和地址
export const updateOrder = (data, param) => {
    return new_request({
        url:'/v2/order/update',
        method: 'put_body',
        data: data,
        param: param
    })
}

//创建订单
export const createOrder = (parmas)=> {
    return request({
        url:'/v2/order/create',
        method: 'post',
        data:parmas
    })
}

//删除订单
export const deleteOrder = (orderId) => {
    return request({
        url:'/v2/order/',
        method: 'delete_path',
        data: orderId
    })
}

//修改订单状态
export const updateStatusOrder = (orderId,orderState) => {
    return request({
        url:'/order/process?orderId='+orderId+"&orderState="+orderState,
        method: 'post',
    })
}

export const batchChange = (parmas) => {
    return new_request( {
        url: '/v2/order/examineBatch',
        method: 'put_body',
        param: "",
        data: parmas
    })
}

//产品列表
export const productList = (parmas) => {
    return request( {
        method: 'post',
        url: '/v2/product/search',
        data: parmas,
    })
}

export const createProduct = (parmas) => {
    return request( {
        method: 'post',
        url: '/v2/product',
        data: parmas,
    })
}

export const updateProduct = (param, body) => {
    return new_request( {
        method: 'put_body',
        url: '/v2/product',
        data: body,
        param: param
    })
}

export const removeProduct = (parmas) => {
    return request( {
        method: 'delete_path',
        url: '/v2/product/',
        data: parmas,
    })
}

export const fileUpload = (parmas) => {
    return request( {
        method: 'post',
        url: '/v1/file/upload',
        data: parmas,
    })
}

//删除产品
export const deleteProduct = (productId) => {
    return request({
        url: '/product/delete?productId=' + productId,
        method: 'post',
    })
}

//获取产品规格
export const expressDetail =() => {
    return request({
        url:'/express/details/list',
        method:'get'
    })
}

//获取产品快递费
export const expressFee =(productSpec,productNum) => {
    return request({
        url:'/express/details/expressFee?productSpec='+productSpec+"&productNum="+productNum,
        method:'get'
    })
}


//用户列表
export const userList = (params) => {
    return request({
        url: '/v2/list',
        method: 'get_path',
        data: params
    })
}

export const getUser = (parmas) => {
    return request({
        url: '/v2/'+parmas,
        method: 'get',
        parmas: {userId:parmas}
    })
}

export const enableUser = (parma1, param2) => {
    return new_request({
        url: '/v2/enable/'+ parma1,
        method: 'put_param',
        param: param2,
        data: null
    })
}

export const getBankList = (parmas) => {
    return request({
        method: 'get',
        url: '/v2/enum/bank',
        data: parmas,
    })
}

//新增用户
export const createUser = (parmas) => {
    return request({
        method: 'post',
        url: '/v2/user',
        data: parmas,
    })
}

//修改用户
export const updateUser = (parmas) => {
    return new_request({
        url:'/v2/user',
        method: 'put_body',
        param: '',
        data:parmas
    })
    // return request({
    //     url: '/user/admin/update',
    //     method: 'post',
    //     data:parmas
    // })
}

//删除用户
export const deleteUser = (userId) => {
    return request({
        url: '/user/delete?userId=' + userId,
        method: 'post',
    })
}

//重置密码
export const resetting = (userId) => {
    return request({
        url: '/user/resetting?userId=' + userId,
        method: 'get',
    })
}

//角色列表
export const roleList = () => {
    return request({
        url: '/role',
        method: 'get',
    })
}

//角色新增
export const createRole = (parmas) => {
    return request({
        url: '/role',
        method: 'put',
        data:parmas
    })
}

//角色修改
export const updateRole = (parmas) => {
    return request({
        url: '/role',
        method: 'post',
        data:parmas
    })
}
//角色删除
export const deleteRole = (roleId) => {
    return request({
        url: '/role?roleId='+roleId,
        method: 'delete',
    })
}

// //保存权限
export const  saveEnterprisePermissions = (parmas) => {
    return request({
        url: '/role/autho',
        method: 'put',
        data: parmas
    })
}

// //查询角色菜单权限
export const  getPermissionTree = (roleId) => {
    return request({
        url: '/role/autho?roleId='+roleId,
        method: 'get',
    })
}

//获取产品规格列表
export const expressList = (params) => {
    return request({
        url: '/express/details/list'+params,
        method: 'get'
    })
}

// 修改/新增产品规格列表
// export const updateExpree = (params) => {



    // return request({
    //     url: '/express/details/update',
    //     method: 'post',
    //     params: data
    // })
// }

//删除产品规格
export const deleteExpree = (params) => {
    return request({
        url: '/express/details/remove?productSpec='+params,
        method: 'post',
    })
}



